import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";


/**
 * 
 */




export const SignInButton = () => {
    const { instance,accounts  } = useMsal();

    const handleLogin = (loginType) => {

        
    
            instance.loginRedirect(loginRequest).catch(e => {
          
            });
        }

    


    return (
       <>
           <p>You are signed out</p> 
        

            <button type= "button" className="button" onClick={() => handleLogin("redirect")}>Sign in </button>
       </>
            
        
    )
}